var React = require('react');

function RightSmall (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st0{fill:none;stroke:#423D33;stroke-width:2;}\r\n\t.st1{fill:#423D33;stroke:#423D33;}\r\n"),React.createElement("circle",{"className":"st0","cx":"24","cy":"24","r":"11","key":1}),React.createElement("path",{"className":"st1","d":"M21.7,19.4l0.7-0.7l5.3,5.3l-5.3,5.3l-0.7-0.7l4.2-4.2l0.4-0.4l-0.4-0.4L21.7,19.4z","key":2})]);
}

RightSmall.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 48 48","style":{"enableBackground":"new 0 0 48 48"},"xmlSpace":"preserve"};

module.exports = RightSmall;

RightSmall.default = RightSmall;
